import { httpClient } from "@/app/client/httpClient";
import { PageableRequest } from "@/types/PageableRequest";

class GiftService {
  async fetchPointGift(giftId: number) {
    const gifts = await httpClient.point_gifts.$get();
    const filteredGift = gifts.results.filter(gift => {
      return gift.id === giftId;
    });
    return filteredGift.length > 0 ? filteredGift[0] : null;
  }

  fetchPointGifts(query?: PageableRequest) {
    return httpClient.point_gifts.$get({
      query
    });
  }

  fetchPointGiftRequests(query?: PageableRequest) {
    return httpClient.point_gifts.requests.$get({
      query
    });
  }

  requestExchange(body: { gift: number }) {
    return httpClient.point_gifts.requests.$post({
      body
    });
  }
}

export const giftService = new GiftService();
